import React from 'react';

const BoxBody = ({ id, text }) => {
    return (
        <div id={id + 'text'} className="boxes-text-wrapper">
            <p className="box-text">{text}</p>
        </div>
    )
}

export default BoxBody;